export const NETWORK_LOG = true;
export const TEST_MODE = false;
export const TEST_REPORT = false;
